<template>
  <div class="alert alert-success ms-3 me-3 " v-bind:class="active ? 'a-show':'a-hide'" role="alert">
    {{message}}
  </div>
</template>

<script>
// import {ref} from 'vue'

export default {
  name: "Alert",
  expose: ['success'],
  data() {
    return {
      active: false,
      message: '',
    }
  },
  methods: {
    success: function (message) {
      this.message = message;
      this.active = true;
      setTimeout(() => this.active = false, 2000);
    }
  }
}
</script>

<style scoped>
.a-show {
  opacity: 1;
  transition: all 0.7s;
}

.a-hide {
  opacity: 0;
  transition: all 2s;
}
</style>